module.exports = __webpack_public_path__ + "static/media/upload-file-static.5824a236.png";